module.exports = __webpack_public_path__ + "static/img/church_02.1f0036f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/church_02.png
// module id = URJ9
// module chunks = 0